const MentionsContextKey = Symbol('MentionsContextKey');
export default MentionsContextKey;